{ td: '1年次', colspan: 1 },

<template>
  <div
    class="hospitalsDetailProgramTable"
    id="js-hospitalsDetailProgramTable"
    v-dragscroll.pass="!isTouchDevice()"
  >
    <table>
      <thead>
        <tr>
          <th></th>
          <th :colspan="4">4月</th>
          <th :colspan="4">5月</th>
          <th :colspan="4">6月</th>
          <th :colspan="4">7月</th>
          <th :colspan="4">8月</th>
          <th :colspan="4">9月</th>
          <th :colspan="4">10月</th>
          <th :colspan="4">11月</th>
          <th :colspan="4">12月</th>
          <th :colspan="4">1月</th>
          <th :colspan="4">2月</th>
          <th :colspan="4">3月</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in data" :key="index">
          <td :colspan="1" :style="`width:  54px; min-height:50px`">
            {{ `${index + 1}` }}<span>年次</span>
          </td>
          <td
            v-for="(el, i) in row"
            :key="i"
            :colspan="+el.weeks"
            :style="`width: ${+el.weeks * 32}px`"
            :class="{ vertical: el.weeks == '1' }"
          >
            <span> {{ el.text }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import ScrollHint from 'scroll-hint'
import '../../../node_modules/scroll-hint/css/scroll-hint.css'
import { isTouchDevice } from '@/utils/commonMethods'

type HospitalsDetailProgramTableProps = {
  id: string
  weeks: string
  text: string
}[]

export default defineComponent({
  name: 'HospitalsDetailProgramTable',
  props: {
    data: {
      type: Array as PropType<HospitalsDetailProgramTableProps[]>,
      default: () => []
    }
  },

  setup(props) {
    const scrollAnime = onMounted(() => {
      new ScrollHint('.hospitalsDetailProgramTable', {
        i18n: {
          scrollable: '横スクロールで表示'
        }
      } as any)
    })

    onMounted(() => {
      const table = document.querySelector('#js-hospitalsDetailProgramTable')
      const tableHead = table?.querySelector('thead')
      let tableHeight = 0
      let tablePosition = 0
      let lastTime = 0

      const setTableInfo = () => {
        tableHeight = table ? table.clientHeight : 0
        tablePosition = table
          ? table.getBoundingClientRect().top + window.pageYOffset
          : 0
      }
      setTableInfo()

      const fixTableHeader = () => {
        const now = Date.now()
        if (now - lastTime < 10) return
        lastTime = now

        if (!tablePosition || !tableHeight) return

        if (
          window.pageYOffset >= tablePosition &&
          window.pageYOffset <= tablePosition + tableHeight
        ) {
          if (tableHead) {
            const diff = window.pageYOffset - tablePosition
            tableHead.style.top = diff + 'px'
          }
        } else {
          tableHead?.setAttribute('style', '')
        }
      }
      document.addEventListener('scroll', fixTableHeader)
      window.addEventListener('resize', setTableInfo)

      onBeforeRouteLeave(() => {
        document.removeEventListener('scroll', fixTableHeader)
        window.removeEventListener('resize', setTableInfo)
      })
    })

    return {
      scrollAnime,
      isTouchDevice
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalsDetailProgramTable {
  overflow-x: auto;
  padding-top: 38px;
  position: relative;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
  table {
    border-spacing: 0;
    margin-bottom: 24px;
    width: 1590px;
    th,
    td {
      border-right: 1px solid var.$color-border-gray;
      font-weight: normal;
      line-height: 1.5;
      text-align: center;
      font-size: 1.2rem;
      &:first-child {
        width: 54px !important;
        border-left: 1px solid var.$color-border-gray;
      }
    }
    tr {
      display: flex;
      width: 1590px;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 1px;
        background-color: var.$color-border-gray;
        z-index: 1;
      }
    }

    thead {
      position: absolute;
      top: 0;
      z-index: 2;
      tr {
        display: flex;
        th {
          width: 128px;
        }
      }
      th {
        background-color: var.$color-other-bg;
        height: 38px;
        border-top: 1px solid var.$color-border-gray;
        display: grid;
        place-content: center;
        &:first-child {
          background-color: #fff;
        }
      }
    }

    tbody {
      td {
        display: grid;
        place-content: center;
        padding: 8px;
        flex: 1 1 auto;
        &:first-child {
          background-color: var.$color-other-bg;
          span {
            writing-mode: vertical-rl;
          }
        }
        &:not(:first-child) {
          border-right: none;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 1px;
            height: 100%;
            background-color: var.$color-border-gray;
          }
        }
        &:last-child {
          text-align: left;
        }
        &.vertical {
          writing-mode: vertical-rl;
          word-break: keep-all;
          white-space: pre;
          letter-spacing: 0.5em;
        }
      }
    }

    th:first-child,
    td:first-child {
      position: sticky;
      left: 0;
      z-index: 1;
    }
  }
}

::v-deep(.scroll-hint-icon-wrap) {
  z-index: 3;
}

::v-deep(.scroll-hint-icon) {
  width: 130px;
  height: 110px;
  padding: 35px 0 10px;
  background-color: rgba(41, 204, 195, 0.9);
}

::v-deep(.scroll-hint-text) {
  font-size: 11px;
  font-weight: 700;
}
</style>
